import { defineNuxtPlugin, useRuntimeConfig } from '#imports';

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();

    const gtmId = config.public.gtm?.id;
    const enabled = config.public.gtm?.enabled;

    if (!enabled || !gtmId) {
        return;
    }

    const loadGTM = () => {
        // Prevent duplicate GTM loading
        if (document.querySelector('script[data-gtm-script]')) {
            return;
        }

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });

        const script = document.createElement('script');

        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
        script.dataset.gtmScript = 'true';

        document.head.appendChild(script);
    };

    const scheduleGTM = () => {
        window.setTimeout(() => {
            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(loadGTM, {
                    timeout: 3000,
                });
            } else {
                loadGTM();
            }
        }, 3000);
    };

    if (document.readyState === 'complete') {
        scheduleGTM();
    } else {
        window.addEventListener('load', scheduleGTM, {
            once: true,
        });
    }
});
